/**
 * Overview Section Component
 * Displays overview title and description
 */

import React from 'react';
import {
  typographyColors,
  spacing,
  typography,
  fontPrimary,
} from '@/design-system/utils';

export interface OverviewSectionProps {
  title: string;
  description: string;
}

export const OverviewSection: React.FC<OverviewSectionProps> = ({
  title,
  description,
}) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: spacing[4],
      }}
    >
      <h2
        style={{
          fontFamily: fontPrimary,
          fontSize: typography.size.lg,
          fontWeight: typography.weight.semibold,
          color: typographyColors.primary,
          lineHeight: 'normal',
        }}
      >
        {title}
      </h2>
      <p
        style={{
          fontFamily: fontPrimary,
          fontSize: typography.size.base,
          fontWeight: typography.weight.regular,
          color: typographyColors.primary,
          lineHeight: 'normal',
        }}
      >
        {description}
      </p>
    </div>
  );
};
